import * as z from 'zod';
/**
 * An instant in time, always serialised as ISO 8601 in UTC.
 *
 * Offsets are rejected on purpose: a single serialisation form removes a whole
 * class of comparison bugs at module boundaries.
 */
export const instantSchema = z.iso.datetime();
const isSupportedTimeZone = (value) => {
    try {
        new Intl.DateTimeFormat('en-US', { timeZone: value });
        return true;
    }
    catch {
        return false;
    }
};
/** An IANA time zone identifier, for example `Europe/Istanbul`. */
export const timeZoneSchema = z
    .string()
    .min(1)
    .refine(isSupportedTimeZone, { message: 'Unknown IANA time zone' });
/**
 * A wall-clock time of day in `HH:mm`, interpreted in a family's time zone.
 *
 * Deliberately not an instant: "allowed until 19:00" must survive travel and
 * daylight saving transitions.
 */
export const timeOfDaySchema = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/, {
    message: 'Expected HH:mm',
});
/** A non-negative duration in whole seconds. */
export const durationSecondsSchema = z.int().nonnegative();
/**
 * Elapsed time measured against a monotonic clock, in milliseconds.
 *
 * Session length is measured this way rather than by subtracting wall-clock
 * timestamps, so that changing the device clock cannot reset a screen-time
 * budget. The wall clock is used only to decide which named hours apply.
 */
export const monotonicElapsedMsSchema = z.int().nonnegative();
/** An instant paired with the time zone it should be interpreted in. */
export const zonedInstantSchema = z.object({
    instant: instantSchema,
    timeZone: timeZoneSchema,
});
export const dayOfWeekSchema = z.enum(['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN']);
//# sourceMappingURL=time.js.map